'use strict';


export function timeFilter($filter) {
	'ngInject';

	return function filter(seconds) {
		if (seconds == null) return '-';
		return $filter('date')(new Date(0, 0, 0).setSeconds(seconds), 'H:mm:ss');
	};
}
